/**
 * Pick a category-themed placeholder for events that don't have a hero image.
 * Adds visual variety to the events grid instead of the same SVG everywhere.
 */
const KNOWN = new Set(['festival', 'market', 'family', 'music', 'sport']);

export function eventPlaceholder(category) {
  const c = (category || '').toLowerCase();
  if (KNOWN.has(c)) return `/event-placeholder-${c}.svg`;
  return '/event-placeholder.svg';
}
